import { createFileRoute } from "@tanstack/react-router";
import { TenantDetail } from "../-tenants/TenantDetail";

export const Route = createFileRoute("/admin/tenants/$workspaceId")({
  staticData: { title: "Tenant" },
  component: TenantDetail,
});
